import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCheckmarkCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.3403 9.96967C15.6332 10.2626 15.6332 10.7374 15.3403 11.0303L11.8203 14.5503C11.6788 14.6919 11.4865 14.771 11.2864 14.77C11.0862 14.769 10.8947 14.6881 10.7545 14.5452L8.71455 12.4652C8.42451 12.1694 8.42912 11.6946 8.72484 11.4045C9.02057 11.1145 9.49542 11.1191 9.78546 11.4148L11.2952 12.9542L14.2797 9.96967C14.5726 9.67678 15.0474 9.67678 15.3403 9.96967Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
		fill: "currentColor"
	})]
});
export { SvgIconCheckmarkCircle as ReactComponent };
